(function () {
    'use strict';

    angular.module("imApp").factory("oeeMenuService", [function () {
        let service = {};

        return service;
    }]);
})();
